import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/login.css";
import { API_BASE, setCsrfToken } from "../../services/server";
import { fetchMe } from "../../services/auth";
import { useAuth } from "../../services/AuthContext";
import { aiPortalUrl } from "../../services/hostRouting";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
  e.preventDefault();
  setError(null);

  // 1) get CSRF token from API response (not cookie — works cross-subdomain + Safari)
  const csrfRes = await fetch(`${API_BASE}/users/auth/csrf/`, {
    credentials: "include",
  });
  const csrfData = await csrfRes.json().catch(() => ({}));
  const csrftoken = csrfData.csrftoken;
  if (csrftoken) setCsrfToken(csrftoken);

  // 2) login with CSRF header
  const res = await fetch(`${API_BASE}/users/auth/login/`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": csrftoken,
    },
    body: JSON.stringify({ username, password }),
  });

if (!res.ok) {
  const data = await res.json().catch(() => ({}));
  setError(data.detail || `Login failed (${res.status})`);
  return;
}

  // AuthContext only loads /auth/me/ once on app mount. Without this refresh,
  // pages reading useAuth().user after SPA-navigating away from /login would
  // see the pre-login null state until a hard refresh.
  let me = null;
  try {
    me = await fetchMe();
    setUser(me);
  } catch {
    // non-fatal — pages that need user data will fetch it themselves
  }

  // Step 17 — route AI-side users to the AI subdomain. Hard redirect
  // (not react-router navigate) because we're crossing subdomains and
  // index.js selects AIApp vs App at boot time based on hostname.
  if (me?.global_nav?.is_ai) {
    const url = aiPortalUrl("/");
    if (url) {
      window.location.href = url;
      return;
    }
  }

  navigate("/projects");
}



  return (
    <div className="login-wrapper">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Logga in</h1>

        <div className="login-field">
          <label>Email</label>
          <input
            type="email"
            autoComplete="username"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
        </div>

        <div className="login-field">
          <label>Lösenord</label>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>

        {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}

        <button type="submit" className="login-button">Logga in</button>

        <div className="login-links">
          <a href="/forgot-password">Glömt lösenord?</a>
        </div>
      </form>
    </div>
  );
}
